// extracted by mini-css-extract-plugin
module.exports = {"centered":"pyxis_centered__h0Nh4"};